export const strlimit = (text, count = 120) => {
  if (text.length > count) {
    return text.substr(0, count) + '...'
  } else {
    return text
  }
}

export const generateString = (length = 6) => {
  const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}
